module.exports = __webpack_public_path__ + "static/media/cancelado.4f953713.svg";